import { h, render } from 'preact';
import { Wistia } from '../../../../../../../wistia_namespace.ts';
import Control from '../../../shared/controls/Control.js';
import ThumbnailTextOverlay from './ThumbnailTextOverlay.jsx';
import { defineControl } from '../../../../../../shared/control_definitions.js';

class ThumbnailTextOverlayControl extends Control {
  constructor(video) {
    super(video);
    this.unbinds.push(
      video.on('play', () => {
        this._hasPlayed = true;
        this.renderThumbnailTextOverlay();
      }),
      video.on('playrejected', this.renderThumbnailTextOverlay),
      video.on('playpending', this.renderThumbnailTextOverlay),
      video.on('end', this.renderThumbnailTextOverlay),
    );
  }

  mount(rootElem) {
    this.rootElem = rootElem;
    this.renderThumbnailTextOverlay();
  }

  renderThumbnailTextOverlay = (width, height) => {
    return new Promise((resolve) => {
      if (this.shouldShow()) {
        const plugin = this.video.plugin.thumbnailTextOverlay;
        if (!plugin) {
          resolve();
        } else {
          render(
            <ThumbnailTextOverlay
              width={width || this.props.videoWidth}
              height={height || this.props.videoHeight}
              text={plugin.getText()}
              onTextFitted={resolve}
            />,
            this.rootElem,
          );
          this.reactMounts = [this.rootElem];
        }
      } else {
        this.rootElem.style.display = 'none';
        resolve();
      }
    });
  };

  onControlPropsUpdated(prevProps) {
    if (
      prevProps.videoWidth !== this.props.videoWidth ||
      prevProps.videoHeight !== this.props.videoHeight
    ) {
      this.renderThumbnailTextOverlay();
    }
  }

  shouldShow() {
    return Wistia._controlDefinitions.thumbnail.shouldShow.call(this);
  }
}

ThumbnailTextOverlayControl.handle = 'thumbnailTextOverlay';
ThumbnailTextOverlayControl.type = 'background';
ThumbnailTextOverlayControl.sortValue = 2010;
ThumbnailTextOverlayControl.shouldMount = (video) => {
  return video.plugin.thumbnailTextOverlay;
};

defineControl(ThumbnailTextOverlayControl);
